<template>
  <!-- Select de direcciones (Cliente Final) con buscador Select2.
       El aspecto lo da admin-tables.css (.select-direccion), igual que un .form-control;
       el CSS base de Select2 se importa en main.js, antes de admin-tables.css. -->
  <div class="select-direccion">
    <select ref="select" :id="id">
      <option value=""></option>
      <option v-for="item in options" :key="item.id" :value="String(item.id)">
        {{ item.nombre + ' - ' + item.direccion }}
      </option>
    </select>
  </div>
</template>

<script>
import $ from 'jquery'
import 'select2'

export default {
  name: 'SelectDireccion',
  props: {
    value: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Seleccione una dirección' },
    id: { type: String, default: null },
  },
  mounted() {
    const $select = $(this.$refs.select)
    // Dentro de un modal la lista se dibuja en el modal (si no, queda detrás de él)
    const $modal = $select.closest('.modal')
    $select.select2({
      width: '100%',
      placeholder: this.placeholder,
      dropdownParent: $modal.length ? $modal : $(document.body),
      language: {
        noResults: () => 'No se encontraron direcciones',
        searching: () => 'Buscando…',
      },
    })
    // Se devuelve el id original (número) y no el texto del <option>
    $select.on('select2:select', () => {
      const elegido = this.options.find(item => String(item.id) === $select.val())
      const valor = elegido ? elegido.id : ''
      this.$emit('input', valor)
      this.$emit('change', valor)
    })
    this.sincronizar()
  },
  beforeDestroy() {
    const $select = $(this.$refs.select)
    $select.off('select2:select')
    if ($select.data('select2')) $select.select2('destroy')
  },
  watch: {
    value() {
      this.$nextTick(this.sincronizar)
    },
    // Las opciones llegan después (al elegir la empresa): se espera a que Vue pinte los <option>
    options() {
      this.$nextTick(this.sincronizar)
    },
  },
  methods: {
    sincronizar() {
      const $select = $(this.$refs.select)
      const valor = this.value === null || this.value === undefined ? '' : String(this.value)
      $select.val(valor).trigger('change.select2')
    },
  },
}
</script>
